import { VFC } from 'react';

import styles from './LoadingCard.module.scss';

type Props = {
  message?: string;
};

const LoadingCard: VFC<Props> = ({ message = 'Loading...' }: Props) => {
  return (
    <div className={styles.loadingCard}>
      <div className={styles.spinner}>
        <span>Loading</span>
      </div>
      {message}
    </div>
  );
};

export default LoadingCard;
